import React, { Component } from 'react';
import { ContainerLeft, ContainerMid, ContainerRight } from './chapters/index';


class Chapter extends Component {
    render() {
        return (
            <section className="chapter-section section-padding dark-bg" id="chapters">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-12">
                            <div className="center-heading mb-60">
                                <h3 className="heading-title">Why Choose ExpertEdge Publications?</h3>
                                <p>Our platform is a hub of knowledge, designed to inspire, educate, and empower readers worldwide.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <ContainerLeft />
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <ContainerMid />
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <ContainerRight />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Chapter;
